var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-topic"},[_c('div',{staticClass:"help"},[_c('div',{staticClass:"reading"},[_c('h2',{staticClass:"help-heading"},[_c('router-link',{attrs:{"to":`/help`}},[_vm._v("Help / ")]),_vm._v("Preloading custom fonts ")],1),_c('QueryString')],1)]),_c('div',{staticClass:"example"})])
}
var staticRenderFns = []

export { render, staticRenderFns }